import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripeCheckoutForm, { StripeCheckoutFormProps } from './StripeCheckoutForm';

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

/**
 * Stripe Payment Element for the invoice's PaymentIntent. Stripe decides which payment methods are shown
 * (cards, Google Pay, Apple Pay, ...) from the account's settings, so nothing is hard-coded here.
 */
export default function StripePayment({ clientSecret, ...form }: StripeCheckoutFormProps & { clientSecret: string }) {
  if (!stripePromise) return <p role="alert" className="text-red-600">Payments are not configured (REACT_APP_STRIPE_PUBLISHABLE_KEY is missing).</p>;
  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret, appearance: { theme: 'stripe', variables: { colorPrimary: '#16a34a', borderRadius: '0.375rem' } } }}
    >
      <StripeCheckoutForm {...form} />
    </Elements>
  );
}
